import React, { createContext, useContext, useEffect } from "react";
import { useState, useCallback } from "react";
import axios from "axios";
import { useLanguageRegion } from "./LanguageRegionContext";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const _apiBase = "https://api.facescan.pro";
  const { clearStorage } = useLanguageRegion();

  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );

  const [tempToken, setTempToken] = useState(localStorage.getItem("tempToken"));
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(accessToken));
  const [role, setRole] = useState(localStorage.getItem("role") || "user");

  const fetchTempToken = useCallback(async () => {
    try {
      const res = await axios.get(`${_apiBase}/users/temp_user_create/`);
      const token = res.data?.temp_token;

      if (token) {
        setTempToken(token);
        localStorage.setItem("tempToken", token);
        return token;
      }
    } catch (e) {
      console.error("Failed to fetch temp token", e);
    }
  }, []);

  const login = (token, userRole) => {
    // Reset language and region to defaults on login
    clearStorage();
    setAccessToken(token);
    setTempToken(null);
    setIsLoggedIn(true);
    setRole(userRole);
    localStorage.setItem("role", userRole);
    localStorage.setItem("accessToken", token);
    localStorage.removeItem("tempToken");
  };

  const logout = (navigate, previousPath) => {
    setAccessToken(null);
    setTempToken(null);
    setIsLoggedIn(false);
    setRole("user")
    localStorage.removeItem("role");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tempToken");
    // Reset language and region to defaults on logout
    clearStorage();

    navigate("/success", { state: { redrectPath: previousPath } });
  };

  useEffect(() => {
    if (!accessToken && !tempToken) {
      fetchTempToken();
    }
  }, [fetchTempToken, accessToken, tempToken]);

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        tempToken,
        fetchTempToken,
        setAccessToken,
        setTempToken,
        isLoggedIn,
        role,
        setRole,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
